import { Box, Group, Text, UnstyledButton } from '@mantine/core'
import { IconCornerDownLeft } from '@tabler/icons-react'
import { SectionLabel } from './SectionLabel'

// Paraphrase of the player's last meaningful choice, shown at the top of the
// Story Column. Replaces generic beat-name headers. The paraphrase currently is
// a truncation of the committed choice_text (can graduate to AI paraphrase).
function paraphrase(text, max = 90) {
  if (!text) return ''
  const clean = text.trim().replace(/\s+/g, ' ')
  return clean.length > max ? `${clean.slice(0, max - 1).trimEnd()}…` : clean
}

// The Recall section is always present on the player screen so the layout never
// jumps as decisions come and go. When there's no prior committed choice yet
// (story start, or before the first decision), the section renders its label and
// reserved space but stays blank instead of collapsing.
export function RecallBanner({ recallText, onReview }) {
  const hasRecall = !!recallText
  return (
    <Box px="lg" pt="sm" pb="xs">
      <SectionLabel>Recall</SectionLabel>
      <Group justify="space-between" wrap="nowrap" gap="sm" align="flex-start">
        {hasRecall ? (
          <Text size="sm" style={{ minWidth: 0 }}>
            <Text span fw={700} c="dimmed" mr={6} style={{ textTransform: 'uppercase', letterSpacing: '0.06em', fontSize: 'calc(0.7rem * var(--bw-content-scale, 1))' }}>
              Previously
            </Text>
            <Text span fs="italic">"{paraphrase(recallText)}"</Text>
          </Text>
        ) : (
          <Text size="sm" c="dimmed" fs="italic" style={{ minWidth: 0, opacity: 0.6 }}>
            No past decisions yet.
          </Text>
        )}
        {hasRecall && onReview && (
          <UnstyledButton onClick={onReview} style={{ flexShrink: 0 }}>
            <Group gap={4} wrap="nowrap">
              <Text size="xs" c="dimmed">review past beats</Text>
              <IconCornerDownLeft size={13} style={{ opacity: 0.6 }} />
            </Group>
          </UnstyledButton>
        )}
      </Group>
    </Box>
  )
}
